module.exports = __webpack_public_path__ + "img/800-gambler.f03bac84.png";